<form class="details-screen" [formGroup]="formGroup">
	<bb-page-header [backOnMobile]="['/publication/api-keys']" [icon]="'key'" [title]="isNew ? ('NEW_API_KEY' | translate) : apikey.label">
		
		<ul class="tabs">
			<li>
				<a class="active">
					<i class="fa fa-key"></i> {{ 'DETAILS' | translate }}
				</a>
			</li>
		</ul>
		<bb-status *ngIf="apikey" [(ngModel)]="apikey.status" formControlName="status" [valueOn]="'active'" [valueOff]="'inactive'" [labelOn]="'ACTIVE' | translate" [labelOff]="'INACTIVE' | translate" ></bb-status>
	</bb-page-header>

	<div class="body-column" *ngIf="entity">

		<div class="left-column">

			<h3>{{'INFORMATION' | translate}}</h3>

			<bb-form-element [control]="formGroup.controls.label" label="{{'LABEL' | translate}}">
				<input type="text" [(ngModel)]="apikey.label" formControlName="label" />
			</bb-form-element>
			
			<bb-form-element [control]="formGroup.controls.description" label="{{'DESCRIPTION' | translate}}">
				<textarea [(ngModel)]="apikey.description" type="text" formControlName="description">{{apikey.description}}</textarea>
			</bb-form-element>

			<bb-form-element [control]="formGroup.controls.secret" label="{{'SECRET' | translate}}" [helpMessage]="'HELP.API_KEY_SECRET' | translate">
				<button *ngIf="!isNew" class="button right" (click)="getApiSecret();showSecret = !showSecret;$event.preventDefault()">
					<i class="fa" [class.fa-eye]="!showSecret" [class.fa-eye-slash]="showSecret"></i>

					{{ ( showSecret ? 'HIDE_SECRET' : 'SHOW_SECRET') | translate }}
				</button>
				<span *ngIf="!isNew && showSecret">{{ apiSecret }} 
					<button *ngIf="!isNew && showSecret" class="button right" [title]="'COPY_TO_CLIPBOARD' | translate" (click)="copyToClipboard(apiSecret, 'COPIED_SECRET_TO_CLIPBOARD')">
						<i class="fa fa-copy"></i>
						{{ 'COPY' | translate }}
					</button>
				</span>
				<span *ngIf="!isNew && apiSecret && !showSecret"><span *ngFor="let c of (apiSecret.split(''))">*</span></span>
				<span *ngIf="!isNew && !apiSecret && !showSecret">********************************</span>
				<em *ngIf="isNew">
					{{'A_SECRET_WILL_BE_GENERATED_UPON_SAVE' | translate}}
				</em>
			</bb-form-element>
			
			<ng-container *ngIf="!isNew">
				<h3>{{'DETAILS' | translate}}</h3>
				<bb-form-element [control]="formGroup.controls.id" label="{{'ID' | translate}}">
					<div class="input">{{ apikey.id }}</div>
				</bb-form-element>
				<bb-form-element [control]="formGroup.controls.createddate" label="{{'CREATED' | translate}}">
					<div class="input" [title]="apikey.createddate | bbDate">{{ apikey.createddate | bbDate:'relative'}}</div>
				</bb-form-element>
				<bb-form-element [control]="formGroup.controls.updateddate" label="{{'UPDATED' | translate}}">
					<div class="input" [title]="apikey.updateddate | bbDate">{{ apikey.updateddate | bbDate:'relative'}}</div>
				</bb-form-element>
			</ng-container>
		</div>
		<div class="right-column" [class.old-roles]="legacyRoles">
			<h3>{{'ROLES' | translate}}</h3>
			<bb-form-element [control]="formGroup.controls.roles">
				<input type="hidden" formArrayName="roles"/>

				<ul class="role-list">
					<li *ngFor="let role of roles; let i = index">
						<label [class.no-pointer]="role.disabled">
							<bb-check [(ngModel)]="role.checked" [checked]="role.checked" (ngModelChange)="roleChanged(role, $event)"
								[ngModelOptions]="{standalone: true}" [disabled]="role.disabled"></bb-check>
							<span>
								{{role.label || role.name}}
								<bb-info *ngIf="!legacyRoles" [contents]="role.help | translate" [icon]="'info'"></bb-info>
							</span>
						</label>
					</li>
					<ng-container *ngIf="extraRoles">
						<h3 class="access-roles">{{'ACCESS_ROLES' | translate}}</h3>
						<li *ngFor="let role of extraRoles">
							<label>
								<bb-check [(ngModel)]="role.checked" [checked]="role.checked" (ngModelChange)="roleChanged(role, $event)"
									[ngModelOptions]="{standalone: true}"></bb-check>
								<span>
									{{role.label || role.name}}
									<bb-info [contents]="role.help | translate" [icon]="'info'"></bb-info>
								</span>
							</label>
						</li>
					</ng-container>
				</ul>
			</bb-form-element>
			<button [hasPermission]="'root'" class="button" (click)="switchPermission()"><i class="fa fa-user"></i>{{ (legacyRoles ? 'MODERN_ROLES' : 'LEGACY_ROLES') | translate }}</button>
		
			<bb-entity-details
				[entity]="entity"
			></bb-entity-details>
		</div>
	</div>
</form>
<bb-actions-bar (onSave)="save($event)" (onCancel)="cancel()" (onDelete)="delete($event)" [formGroup]="formGroup" [entity]="entity"></bb-actions-bar>
